<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de viagem geral">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/relatorio-viagem-geral/List'

export default {
    components: { List },
}
</script>
